import api from './api'

export const customerTypeService = {
  fetchList() {
    return api.get('/therapy/customer-types')
  },
  create(payload) {
    return api.post('/therapy/customer-types', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/customer-types/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/customer-types/${id}/status`, null, { params: { status } })
  },
  assign(userId, customerTypeId) {
    return api.patch(`/therapy/customer-types/users/${userId}/customer-type`, null, { params: { customerTypeId } })
  }
}
